import { render, staticRenderFns } from "./AuthLoginViaSSO.vue?vue&type=template&id=9090bed0&scoped=true"
import script from "./AuthLoginViaSSO.vue?vue&type=script&lang=js"
export * from "./AuthLoginViaSSO.vue?vue&type=script&lang=js"
import style0 from "./AuthLoginViaSSO.vue?vue&type=style&index=0&id=9090bed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9090bed0",
  null
  
)

export default component.exports